/**
 * React remount key for the assignment pane. roomStateId is deliberately NOT
 * part of it: the room is a sub-selection within one assignment, synced into
 * the live cubit in place (see StudentAssignmentPage). Keying on it rebuilt the
 * whole page on every room change, and a stale or foreign room in the URL could
 * ping-pong the key and spin getSlideDeckForAssignment (the call-volume loop).
 */
export const assignmentPaneKey = (assignmentId: string, sectionId: string) =>
  `assignment-${assignmentId}-${sectionId}`
